import { s as subscribe } from "../../../../../../chunks/utils.js";
import { c as create_ssr_component, e as escape, v as validate_component } from "../../../../../../chunks/ssr.js";
import "../../../../../../chunks/project.js";
import "../../../../../../chunks/qualification.js";
import "dayjs";
import { S as Spinner } from "../../../../../../chunks/Spinner.js";
import "../../../../../../chunks/api.js";
/* empty css                                                                   */
import "../../../../../../chunks/address.js";
import "../../../../../../chunks/customer.js";
import "../../../../../../chunks/customer2.js";
import { P as PageLayout } from "../../../../../../chunks/PageLayout.js";
import { c as currentRoute } from "../../../../../../chunks/route.js";
import "dayjs/plugin/relativeTime.js";
import "file-selector";
/* empty css                                                              */
import "../../../../../../chunks/files.js";
import "../../../../../../chunks/convertPdfToImage.js";
import "../../../../../../chunks/modal.js";
import "../../../../../../chunks/i18nDate.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_currentRoute;
  $$unsubscribe_currentRoute = subscribe(currentRoute, (value) => value);
  let { data } = $$props;
  let project;
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1qkq5e2_START -->${$$result.title = `<title>${escape(project?.name)}</title>`, ""}<!-- HEAD_svelte-1qkq5e2_END -->`, ""} ${validate_component(PageLayout, "PageLayout").$$render($$result, {}, {}, {
      default: () => {
        return `${`<div class="text-center my-5">${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}</div>`}`;
      }
    })}`;
  } while (!$$settled);
  $$unsubscribe_currentRoute();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
